import React, { useState } from 'react';
import { siteData } from '../../data/mock';
import { ArrowUpRight } from 'lucide-react';

const FAQ = () => {
  const { faq } = siteData;
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section id="faq" className="py-[60px] md:py-[80px] bg-[#f7f8fc]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
        <h2 className="text-[28px] md:text-[34px] font-bold text-center text-[#1a1a2e] mb-8 md:mb-12 leading-tight">
          {faq.title}
        </h2>

        <div className="flex flex-col md:flex-row gap-6 md:gap-10">
          {/* Questions list */}
          <div className="w-full md:w-7/12">
            <div className="space-y-0">
              {faq.items.map((item, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-full flex items-center justify-between py-5 px-4 text-left border-b border-gray-200 transition-colors cursor-pointer bg-transparent ${
                    activeIndex === index
                      ? 'border-l-2 border-l-[#0E47B0]'
                      : 'border-l-2 border-l-transparent hover:bg-gray-50'
                  }`}
                >
                  <h3 className={`text-[16px] md:text-[17px] font-semibold pr-4 ${
                    activeIndex === index ? 'text-[#0E47B0]' : 'text-[#1a1a2e]'
                  }`}>
                    {item.question}
                  </h3>
                  <ArrowUpRight
                    size={20}
                    className={`flex-shrink-0 transition-transform ${
                      activeIndex === index ? 'text-[#0E47B0] rotate-0' : 'text-[#1a1a2e]/50 rotate-45'
                    }`}
                  />
                </button>
              ))}
            </div>
          </div>

          {/* Answer panel */}
          <div className="w-full md:w-5/12">
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm min-h-[200px]">
              <p className="text-[15px] text-[#4a4a6a] leading-[1.8]">
                {faq.items[activeIndex]?.answer}
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-8 md:mt-12">
          <a
            href="#form-main"
            className="inline-block px-8 py-3.5 bg-gradient-to-r from-[#0E47B0] to-[#1a5dd4] hover:from-[#0d3d96] hover:to-[#1650b8] text-white font-bold text-sm tracking-wider rounded-lg transition-all no-underline"
          >
            {faq.ctaText}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
